



import { useContext, useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../context/Context";
import toast from "react-hot-toast";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, fireDB } from "../../firebase/FirebaseConfig";
import Loader from '../../components/Loader/Loader'
import { collection, onSnapshot, query, where } from "firebase/firestore";
import './Login.css';
import { use } from "react";

function Login() {


  const [loading, setLoading] = useState(false);

    // navigate 
    const navigate = useNavigate();

    // User Signup State 
    const [userLogin, setUserLogin] = useState({
        email: "",
        password: ""
    });


        const userLoginFunction = async (e) => {
          e.preventDefault();
          // validation 
          if (userLogin.email === "" || userLogin.password === "") {
              toast.error("All Fields are required")
          } else if(userLogin.password.length<6){
            toast.error("check email or password or register")
          }
  
          setLoading(true);
          try {
              const users = await signInWithEmailAndPassword(auth, userLogin.email, userLogin.password);
              // console.log(users.user)
  
              try {
                  const q = query(
                      collection(fireDB, "user"),
                      where('uid', '==', users?.user?.uid)
                  );
                  const data = onSnapshot(q, (QuerySnapshot) => {
                      let user;
                      QuerySnapshot.forEach((doc) => user = doc.data());

                      localStorage.setItem("users", JSON.stringify(user) )
                      
                    //   setUserLogin({
                    //       email: "",
                    //       password: ""
                    //   })
                      toast.success("Login Successfully");
                      setLoading(false);

                      if(user.role === "user") {
                          navigate('/userDashboard');
                      }else if(user.role === "seller") {
                        navigate('/sellerDashboard');
                      }
                      else {
                          navigate('/adminDashboard');
                          
                      }
                  });

                  return () => data;
              } catch (error) {
                  console.log(error);
                  setLoading(false);
              }
          } catch (error) {
              console.log(error);
              setLoading(false);
              toast.error("Login Failed");
          }
        }
  
        useEffect(() => {
          // Scroll to the top when the component loads
          window.scrollTo(0, 0);
         
      }, []);
        
 return (
   <div className="min-h-screen bg-[#fdf7f7] flex items-center justify-center px-6">
     <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-center">
       {/* 🔹 Left Image Section */}
       <div className="hidden md:flex justify-center">
         <img
           src="https://i.pinimg.com/736x/8a/d7/4f/8ad74f79b218d4ee39e48cdcd5486cbb.jpg"
           alt="Wedding"
           className="rounded-2xl shadow-lg w-[60%]"
         />
       </div>

       {/* 🔹 Right Login Form */}
       <div>
         <h2 className="text-4xl font-serif text-gray-800 mb-4">
           Welcome Back
         </h2>
         <p className="text-gray-500 mb-8">
           Sign in to continue planning your dream wedding
         </p>

         <form className="space-y-6">
           {/* Email */}
           <div>
             <label className="block text-lg font-quicksand text-gray-700 mb-2">
               Email*
             </label>
             <input
               type="email"
               value={userLogin.email}
               onChange={(e) =>
                 setUserLogin({
                   ...userLogin,
                   email: e.target.value,
                 })
               }
               placeholder="mail@website.com"
               className="w-full rounded-full border border-gray-300 px-5 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none"
             />
           </div>

           {/* Password */}
           <div>
             <label className="block text-lg font-quicksand text-gray-700 mb-2">
               Password*
             </label>
             <input
               type="password"
               value={userLogin.password}
               onChange={(e) =>
                 setUserLogin({
                   ...userLogin,
                   password: e.target.value,
                 })
               }
               placeholder="Enter your password"
               className="w-full rounded-full border border-gray-300 px-5 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none"
             />
           </div>

           {/* Button */}
           <button
             onClick={userLoginFunction}
             disabled={loading}
             className={`w-full py-3 rounded-md font-medium transition duration-300
              ${loading ? "bg-red-700 cursor-not-allowed" : "bg-[#b76d68] text-white"}`}
           >
             {loading ? "Signing..." : "Sign In"}
           </button>

           <p className="text-center text-sm text-gray-600 mt-4">
             Don’t have an account?{" "}
             <Link
               to="/signup"
               className="text-[#b76d68] font-medium hover:underline"
             >
               Create Account
             </Link>
           </p>
         </form>
       </div>
     </div>
   </div>
 );

}

export default Login